import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    offices: [],
    officesLoaded: false,
  }),
  mutations: {
    SET_OFFICES(state, offices) {
      state.offices = offices
      state.officesLoaded = true
    },
  },
  actions: {
    async fetchOffices({ commit, state }) {
      if (!state.officesLoaded) {
        const res = await axios.get('office')
        const data = decryptData(res.data.payload).data.offices
        const formatted = data.map(item => ({
          value: item.id,
          text: item.name,
        }))
        commit('SET_OFFICES', [
          { value: null, text: 'All Offices' },
          ...formatted,
        ])
      }
    },
  },
  getters: {
    offices: state => state.offices,
    officesLoaded: state => state.officesLoaded,
  },
}
